import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import Button from 'components/UI/V3/Button/Button';
import DefaultHeader from 'components/UI/V3/DefaultHeader/DefaultHeader';
import DescriptionText from 'components/UI/V3/DescriptionText';
import SearchBar from 'components/UI/V3/SearchBar/SearchBar';
import { SelectionBar, SelectionBarOption } from 'components/UI/V3/SelectionBar';
import { FunctionComponent } from 'react';

import styles from './EmailCampaignsHeader.module.scss';

interface EmailCampaignsHeaderProps {
    filterOptions: SelectionBarOption[];
    searchText: string;
    selectedFilter: string;
    selectedTotalRecords: number;
    onChangeSearchText: (value: string) => void;
    onChangeFilter: (value: string) => void;
    /** Opens the AddEmailCampaign wizard — same handler wired into the
     *  friendly empty state so both entry points behave identically. */
    onOpenNew: () => void;
    /**
     * Collapses the header to just the section title when the marketplace
     * has no campaigns yet — description, filter tabs, search bar and
     * `New Email Campaign` button all hide so the friendly `EmailCampaigns
     * EmptyState` is the only surface the user sees. Mirrors the same prop
     * on `EmailTemplatesHeader`.
     */
    minimal?: boolean;
}

const EmailCampaignsHeader: FunctionComponent<EmailCampaignsHeaderProps> = ({
    filterOptions,
    searchText,
    selectedFilter,
    selectedTotalRecords,
    onChangeSearchText,
    onChangeFilter,
    onOpenNew,
    minimal = false
}) => {
    const customButton = minimal ? undefined : (
        <Button
            size="medium"
            label="New Email Campaign"
            leftIcon={faPlus}
            onClick={onOpenNew}
        />
    );

    return (
        <div className={styles.header}>
            <DefaultHeader
                title="Marketing Emails"
                customButton={customButton}
            />

            {!minimal && (
                <>
                    <DescriptionText
                        className={styles.headerDescription}
                        text="Design and send email campaigns to connect with your customers, increase bookings, or highlight special promotions."
                    />

                    <div className={styles.selectionBarContainer}>
                        <SelectionBar
                            options={filterOptions}
                            selectedId={selectedFilter}
                            selectedTotalRecords={selectedTotalRecords}
                            onSelect={onChangeFilter}
                            className={styles.selectionBar}
                        />
                    </div>

                    <SearchBar
                        searchText={searchText}
                        onChangeSearchText={onChangeSearchText}
                        placeholder="Search by Campaign name"
                        className={styles.searchBar}
                    />
                </>
            )}
        </div>
    );
};

export default EmailCampaignsHeader;
